import sharedConstants from "@lib/shared_constants";

import type { BrandGuidelineDocumentErrorCode, BrandGuidelineDocumentRequestError } from "./types";

const errors = sharedConstants.GENERATIVE_AI.ERRORS;

const brandGuidelineDocumentErrorCodes: ReadonlySet<string> = new Set<BrandGuidelineDocumentErrorCode>([
  errors.FEATURE_NOT_ENABLED,
  errors.GUIDELINE_NOT_FOUND,
  errors.DOCUMENT_NOT_FOUND,
  errors.DOCUMENT_LIMIT_REACHED,
  errors.INVALID_DOCUMENT_FILE,
  errors.UNSUPPORTED_DOCUMENT_FILE_TYPE,
  errors.EMPTY_DOCUMENT_FILE,
  errors.DOCUMENT_FILE_TOO_LARGE,
  errors.IMAGE_FILE_TOO_LARGE,
]);

const isBrandGuidelineDocumentErrorCode = (code: string): code is BrandGuidelineDocumentErrorCode =>
  brandGuidelineDocumentErrorCodes.has(code);

/**
 * Extracts the typed error code from a rejected brand-guideline-document request (attach, download,
 * or delete). These endpoints respond with an `{ error }` body — not the `error_code`/`message`
 * UserEncodedError envelope — so the code arrives on `FetchRequestError#responseJson`. Returns null
 * when the failure carries no recognized code (network error, 500, etc.), in which case callers
 * should fall back to a generic message.
 */
export const getBrandGuidelineDocumentErrorCode = (
  error: BrandGuidelineDocumentRequestError
): BrandGuidelineDocumentErrorCode | null => {
  const code = error.responseJson?.error;
  if (typeof code === "string" && isBrandGuidelineDocumentErrorCode(code)) {
    return code;
  }
  return null;
};
